import { render, staticRenderFns } from "./live.vue?vue&type=template&id=0f1e3a2f&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=0f1e3a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1e3a2f",
  null
  
)

export default component.exports